function initHeaderLogoAnimation() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.matchMedia({
    /* =============================== DESKTOP ================================ */
    '(min-width: 990px)': function () {
      const logo = document.querySelector('.header__inline-menu .header__heading-link') ||
        document.querySelector('.header__heading-link');
      if (!logo) return;

      const logoPaths = logo.querySelectorAll('svg path');
      const startOffset = window.innerHeight * 0.25;

      // Explicit white start — prevents hard-reload flash to dark fill over the hero
      gsap.set(logoPaths, { fill: '#ffffff' });
      gsap.set(logo, {
        scale: 3,
        y: startOffset,
        transformOrigin: '50% 50%',
        autoAlpha: 1,
      });

      gsap.to(logo, {
        scale: 1,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: document.body,
          start: 'top+=0 top',
          end: '+=100',
          scrub: true,
        },
      });

      gsap.fromTo(
        logoPaths,
        { fill: '#ffffff' },
        {
          fill: '#002a1e',
          ease: 'none',
          immediateRender: false,
          scrollTrigger: {
            trigger: document.body,
            start: 'top+=50 top',
            end: '+=100',
            scrub: true,
          },
        }
      );
    },

    /* =============================== MOBILE ================================ */
    '(max-width: 989px)': function () {
      const logos = document.querySelectorAll('.header__heading-link');
      if (!logos.length) return;

      logos.forEach((logo) => {
        // Skip the mega-menu clone (display:none on mobile)
        if (window.getComputedStyle(logo).display === 'none') return;
        if (logo.closest('.header__inline-menu')) return;

        const logoPaths = logo.querySelectorAll('svg path');
        const startOffset = window.innerHeight * 0.28;
        const logoRect = logo.getBoundingClientRect();
        const currentCenter = logoRect.left + logoRect.width / 2;
        const viewportCenter = window.innerWidth / 2;
        const centerOffset = viewportCenter - currentCenter;

        gsap.set(logoPaths, { fill: '#ffffff' });
        gsap.set(logo, {
          scale: 1.8,
          x: centerOffset,
          y: startOffset,
          transformOrigin: '50% 50%',
          autoAlpha: 1,
        });

        // Keep parent heading visible — CSS opacity:0 would hide the floated logo
        const heading = logo.closest('.header__heading');
        if (heading) gsap.set(heading, { autoAlpha: 1 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: document.documentElement,
            start: 'top top',
            end: '+=120',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });

        tl.fromTo(
          logo,
          { scale: 1.8, x: centerOffset, y: startOffset },
          { scale: 1, x: 0, y: 0, ease: 'none' },
          0
        );

        tl.fromTo(
          logoPaths,
          { fill: '#ffffff' },
          { fill: '#000000', ease: 'none', immediateRender: false },
          0
        );
      });

      window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
      });
    },
  });
}

function whenReadyForLogoAnimation(cb) {
  let started = false;
  const run = () => {
    if (started) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    started = true;
    // Two rAFs: wait until layout/geometry are committed after hard reload
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        cb();
        // Recalculate after full load (fonts/images) so hard reload geometry is correct
        window.addEventListener(
          'load',
          () => {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      })
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
}

whenReadyForLogoAnimation(initHeaderLogoAnimation);
